import util from "../../../util";

const saveSolicitudMaterial = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader();
    payload.context.axios
      .post("oderMateriales/save", payload.material, { headers })
      .then(response => {
        console.log('responde erro',response)
        if(response.data.id){
          payload.context.$toast.open("Pedido registrado correctamente!");
        }else{
          payload.context.$toast.open({ duration: 4000,message:"La cantidad de valijas solicitada supera el stock permitido",type: 'is-warning'});
        }
        resolve(response.data);
      })
      .catch(error => {
        util.showDialogError(
          payload.context,
          "Ocurrió un error al registrar la solicitud."
        );
        reject(error);
      });
  });
};

const loadOrdersMateriales = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader();
    payload.context.axios
      .get(`orderMateriales/${payload.idClient}?${payload.params}`, { headers })
      .then(response => {
        // commit('setListMateriales', response.data)
        resolve(response.data)
      })
      .catch(error => {
        util.showDialogError(
          payload.context,
          "Ocurrió un error al cargar los pedidos materiales."
        );

        reject(error);
      });
  });
};

const deleteItemOrderMaterial = ({ commit } , payload) => {

  return new Promise((resolve, reject) => {

    const headers = util.getAuthHeader()
    payload.context.axios.delete(`oderMateriales/${payload.idOrderMaterial}/${payload.idTipoMaterial}`, {headers}).then((response) => {

      payload.context.$toast.open('Item eliminado correctamente!')

      resolve(response.data)

    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al eliminar el item.')
      reject(error)

    });

  })

}


const cancelOrderMaterial = ({ commit },payload) => {
  return new Promise((resolve,reject)=>{
    const headers = util.getAuthHeader()
    payload.context.axios.delete(`/oderMateriales/${payload.idOrderMaterial}`,{headers}).then((response) => {
      payload.context.$toast.open('Orden Pedido cancelado correctamente!')
      resolve(response.data);
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cancelar el pedido.')
      reject(error)
    });
  })
}

const recepcionarOrderMaterial = ({ commit },payload) => {
  return new Promise((resolve,reject)=>{
    const headers = util.getAuthHeader()
    payload.context.axios.put(`/oderMateriales/recepcionar`,payload.orderMaterial,{headers}).then((response) => {
      payload.context.$toast.open('Orden Recepcionado correctamente!')
      resolve(response.data);
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cancelar el pedido.')
      reject(error)
    });
  })
}


export default {
  saveSolicitudMaterial,
  loadOrdersMateriales,
  deleteItemOrderMaterial,
  cancelOrderMaterial,
  recepcionarOrderMaterial
};



// WEBPACK FOOTER //
// ./src/store/modules/materiales/actions.js